import { REQUEST_TYPE } from '@/constants/request-types';

import fetchData from './fetchData';
import { decryptFile, encryptFile } from './mediaCrypto.js';
import { isBlockedChatMediaFile } from './safeChatMedia';

export const getServer = async (mediaFile, serverLink) => {
    const params = {
        size: mediaFile.size,
        type: mediaFile.type,
    };

    const { data, error } = await fetchData(
        REQUEST_TYPE.GET,
        `${serverLink}/server`,
        params,
    );
    if (data && data.data) {
        return { responseLink: data?.data };
    } else {
        console.error('an error happend');
        return { error: error };
    }
};

export const uploadFiles = async (
    mediaFile,
    subserver,
    responseLink,
    token,
    channelId,
    encrypt = true,
    onUploadProgressCallback,
) => {
    if (
        isBlockedChatMediaFile({
            name: mediaFile.name,
            type: mediaFile.type,
        })
    ) {
        throw new Error('This file type is not allowed for security reasons.');
    }
    let encryptedFile = mediaFile;
    if (encrypt) {
        encryptedFile = await encryptFile(mediaFile);
        encryptedFile = encryptedFile.encryptedFile;
    }
    let formData = new FormData();
    formData.append('upload', encryptedFile, encryptedFile.name);
    formData.append('subserver_id', subserver);
    formData.append('token', token);

    const { data } = await fetchData(
        REQUEST_TYPE.POST,
        responseLink,
        formData,
        {
            meta_data: JSON.stringify({
                type: mediaFile.type,
                name: mediaFile.name,
            }),
            subserver_id: subserver,
            channel_id: channelId,
        },
        {
            Authorization: `Bearer ${token}`,
        },
        null,
        null,
        onUploadProgressCallback,
    );

    return {
        uploadedFileLink: data,
    };
};

export const downloadFile = async (
    props,
    uploadedFileLink,
    token,
    onDownloadProgressCallback,
) => {
    const getFileUrl = `https://${uploadedFileLink.server}/api/info/${uploadedFileLink.fileKey}?token=${token}`;
    const infoResp = await fetchData(REQUEST_TYPE.POST, getFileUrl);
    if (infoResp.error) {
        return { error: infoResp.error };
    }

    const rawMeta = infoResp.data;
    const meta = rawMeta?.data ?? rawMeta;
    const resolvedName = meta?.name ?? uploadedFileLink?.name ?? '';
    const resolvedType = meta?.type ?? uploadedFileLink?.type ?? '';

    if (
        isBlockedChatMediaFile({
            name: String(resolvedName),
            type: resolvedType,
        })
    ) {
        return { error: 'BLOCKED', fileInfo: meta };
    }

    const link = `https://${uploadedFileLink.server}/api/download/${uploadedFileLink.fileKey}?token=${token}`;

    const { error, data } = await fetchData(
        REQUEST_TYPE.POST,
        link,
        {},
        {},
        {},
        { responseType: 'blob' },
        onDownloadProgressCallback,
    );
    if (error) return { error };
    const decryptedData = await decryptFile(data);

    return {
        fileLink: decryptedData?.decryptedFile,
        fileInfo: meta ?? rawMeta,
    };
};
